import { FaqCategory, FaqLink } from "@/lib/types/faqs.ts";
import * as S from "./styles.ts";
import { H6, UniversalLink } from "@template/components";

interface QuestionsProps {
  faqsTitle: string;
  currentCategory: FaqCategory;
}

export const Questions = ({ faqsTitle, currentCategory }: QuestionsProps) => {
  return (
    <S.QuestionsContainer>
      <S.Title>{faqsTitle}</S.Title>
      {currentCategory?.articles.map((article: FaqLink, index: number) => (
        <S.QuestionItem key={index}>
          <UniversalLink
            title={`Learn more about ${article.article_title}`}
            href={`/faq/${article.category_url_key}/${article.url_key}`}
          >
            <H6 as="p">{article.article_title}</H6>
          </UniversalLink>
        </S.QuestionItem>
      ))}
    </S.QuestionsContainer>
  );
};
